export const GENERAL_TOUR_ID = 'platform-overview:v1';
export const GENERAL_STEPS = [
    {
        title: 'Верхняя панель',
        description: 'Здесь находятся профиль, выход из системы и кнопка помощи. Обзор можно остановить и продолжить позже.',
        anchor: 'top-bar',
    },
    {
        title: 'Опытные участки',
        description: 'На главной странице выбирают поле и сезон, смотрят карту и доступные сведения о поле.',
        anchor: 'nav-fields',
    },
    {
        title: 'Внесение данных',
        description: 'Здесь заполняют данные по полям и сезонным работам, если эта функция доступна вашей роли.',
        anchor: 'nav-data-entry',
    },
    {
        title: 'База знаний',
        description: 'В этом разделе собраны подробные материалы. Обзор показывает навигацию и не заменяет инструкции.',
        anchor: 'nav-knowledge-base',
    },
    {
        title: 'Помощь всегда под рукой',
        description: 'Кнопка «Помощь» позволит выбрать короткий обзор или раскрыть его шаги в любой момент.',
        anchor: 'help-button',
    },
];
const DEFAULT_PROGRESS = { status: 'not_started', stepIndex: 0, prompted: false };
export const onboardingStorageKey = (userId) => `terra:onboarding:${userId}`;
export const getTourProgress = (state, tourId) => state.tours[tourId] || DEFAULT_PROGRESS;
export const clampStep = (stepIndex, stepCount) => Math.max(0, Math.min(Number.isInteger(stepIndex) ? stepIndex : 0, stepCount - 1));
export const shouldOfferTour = (state, tourId, role) => {
    if (tourId !== GENERAL_TOUR_ID || state.autoDisabled || (role !== 'Работник' && role !== 'Главный агроном'))
        return false;
    const progress = getTourProgress(state, tourId);
    return !progress.prompted && progress.status === 'not_started';
};
export const shouldOfferFeature = (state, featureTourId, role) => {
    if (state.autoDisabled || (role !== 'Работник' && role !== 'Главный агроном'))
        return false;
    const overview = getTourProgress(state, GENERAL_TOUR_ID);
    if (overview.status !== 'completed' && overview.status !== 'skipped')
        return false;
    const progress = getTourProgress(state, featureTourId);
    return !progress.prompted && progress.status === 'not_started';
};
export const emptyOnboardingState = () => ({ autoDisabled: false, tours: {} });
export const parseOnboardingState = (raw) => {
    if (!raw)
        return emptyOnboardingState();
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || typeof parsed.tours !== 'object' || !parsed.tours) {
            return emptyOnboardingState();
        }
        const tours = {};
        for (const [id, value] of Object.entries(parsed.tours)) {
            const candidate = value;
            if (!candidate || !['not_started', 'paused', 'completed', 'skipped'].includes(candidate.status || ''))
                continue;
            tours[id] = {
                status: candidate.status,
                stepIndex: Number.isInteger(candidate.stepIndex) ? candidate.stepIndex : 0,
                prompted: candidate.prompted === true,
            };
        }
        return { autoDisabled: parsed.autoDisabled === true, tours };
    }
    catch (_a) {
        return emptyOnboardingState();
    }
};
export const setTourProgress = (state, tourId, patch) => (Object.assign(Object.assign({}, state), { tours: Object.assign(Object.assign({}, state.tours), { [tourId]: Object.assign(Object.assign({}, getTourProgress(state, tourId)), patch) }) }));
